import ApplicationSerializer from 'uplisting-frontend/serializers/application';

export default ApplicationSerializer.extend({
  attrs: {
    offlineSecurityDepositFollowsDeposit: {
      serialize: false,
    },
  },
});
